import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import _ from 'lodash';
import { fetchPortCollections, PortCollectionQueryKeys } from 'services/clients/portCollection';
import { PortCollection } from 'types/Port';
import { PortCloud } from './PortCloud';
import { PortCollectionSelector } from './PortCollectionSelector';

interface Props {
  onChange: (portCollections: string[]) => void;
  value: string[];
}

const portSortByName = (p: PortCollection) => p.name;

export const PortCollections: React.FC<Props> = (props) => {
  const { onChange, value } = props;

  const portCollectionQuery = useQuery({
    queryKey: [PortCollectionQueryKeys.PortCollections],
    queryFn: ({ signal }) => fetchPortCollections({ pageSize: 1000 }, signal),
  });

  const availablePortCollections = _.sortBy(
    portCollectionQuery.data?.results ?? [],
    portSortByName
  );

  return (
    <div className="flex items-center flex-col space-y-8 w-full">
      <div className="w-full max-w-[520px]">
        <PortCollectionSelector
          portCollections={availablePortCollections}
          onChange={onChange}
          value={value}
        />
      </div>
      <div className="w-[1000px] max-w-[80vw]">
        <PortCloud
          portCollections={_.sortBy(
            value.map((code) =>
              availablePortCollections.find((p) => p.code === code)
            ) as PortCollection[],
            portSortByName
          )}
          onRemovePort={(port) => onChange(value.filter((p) => p !== port.code))}
        />
      </div>
    </div>
  );
};
PortCollections.displayName = 'CreateCompany.CompanyDetails.Shippers.PortCollections';
